import { render, staticRenderFns } from "./Frequency.vue?vue&type=template&id=08c8557b"
import script from "./Frequency.vue?vue&type=script&lang=js"
export * from "./Frequency.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08c8557b')) {
      api.createRecord('08c8557b', component.options)
    } else {
      api.reload('08c8557b', component.options)
    }
    module.hot.accept("./Frequency.vue?vue&type=template&id=08c8557b", function () {
      api.rerender('08c8557b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/select/Frequency.vue"
export default component.exports